export enum CommercialProposalStatus {
  Draft = "Черновик",
  Created = "Создано",
  Sent = "Отправлено",
  Completed = "Выполнено",
  Expired = "Истёк",
}

export type ProposalCurrency = "USD" | "UZS";

export interface ICommercialProposalItem {
  produceId: string;
  produceName: string;
  unitOfMeasurement?: string;
  basePrice: number;
  /** Мин. цена — пол продажи. */
  minPrice: number;
  /** Макс. скидка (%): минимум из макс. скидки категории и скидки до мин. цены. */
  maxDiscountPercent: number;
  discountPercent: number;
  priceDiscounted: number;
  quantity: number;
  lineTotal: number;
  dailyCapacity?: number;
  leadTimeDays: number;
}

export interface ICommercialProposal {
  _id: string;
  proposalNumber: number;
  version: number;
  status: CommercialProposalStatus;
  currency: ProposalCurrency;
  clientId: string;
  clientName: string;
  clientPhone?: string;
  ownerId: string;
  ownerName: string;
  ownerPhone?: string;
  items: ICommercialProposalItem[];
  totalBaseAmount: number;
  totalDiscountAmount: number;
  totalAmount: number;
  validityDays: number;
  validUntil: string;
  leadTimeDays: number;
  leadTimeDaysAuto: number;
  leadTimeManual: boolean;
  dueDate?: string;
  createdAt: string;
  updatedAt: string;
  updatedByName?: string;
}

export interface ICommercialProposalsResponse {
  total: number;
  page: number;
  limit: number;
  totalPages: number;
  proposals: ICommercialProposal[];
}

/** Информация по продукции для формы КП (цены/мин.цены/макс.скидка). */
export interface IProposalProduceCurrencyInfo {
  basePrice: number;
  /** Пол продажи. */
  minPrice: number;
  /** Макс. скидка категории (% от прайса), если задана. */
  categoryMaxDiscountPercent?: number | null;
  /** Макс. скидка (%): минимум из потолка категории и скидки до мин. цены. */
  maxDiscountPercent: number;
  maxDiscountPrice: number;
}

export interface IProposalProduceOption {
  _id: string;
  name: string;
  unitOfMeasurement?: string;
  /** Остаток на складе. */
  residue: number;
  /** Производственная очередь по активным заказам. */
  queue: number;
  /** Производительность (ед./день) или null, если не задана. */
  dailyCapacity: number | null;
  USD: IProposalProduceCurrencyInfo;
  UZS: IProposalProduceCurrencyInfo;
}

export interface IProposalMeta {
  validityDays: number;
  templateVariant: string;
  defaultDailyCapacity: number | null;
  leadTimeSafetyPercent: number;
  /** Включён ли лимит скидки (мин. цена + макс. скидка клиента). */
  discountLimit: boolean;
  /** Распространяется ли лимит скидки на админа/директора/руководителя. */
  adminDiscountLimit: boolean;
  currencies: ProposalCurrency[];
}

export interface IProposalItemInput {
  produceId: string;
  quantity: number;
  discountPercent: number;
}

export interface ICreateProposalPayload {
  clientId: string;
  currency: ProposalCurrency;
  items: IProposalItemInput[];
  ownerId?: string;
  asDraft?: boolean;
  /** Ручной срок выполнения (только в бо́льшую сторону). */
  leadTimeDays?: number;
}
